import React from 'react'
import BotTarifTable from './botTarifTable'
import { Link } from 'react-router-dom'
import './botTarifs.css'

const BotTarifs = () => {
    return (
        <>
            <div className="botTarifsDiv" id='bot_tarifs'>
                <h1 className="botHeaderText">
                    Тариф сервиса
                </h1>
                <div className='botTarif'>
                    <h1>3,8 руб</h1>
                    <p>минута звонка</p>
                    <Link to={'/registration'}>
                        Увеличить свою прибыль
                        <img src="/static/img/bot/arrowLine.png" alt="" />
                    </Link>
                </div>
                <img className='phoneeithwifi' src="/static/img/bot/phoneeithwifi.png" alt="" />
                <div className="botTarifElipse"><img src="/static/img/bot/coins.png" alt="" /></div>
                <div className="botTarifElipse botTarifElipse_2"><img src="/static/img/bot/coin.png" alt="" /></div>
                <img className='vectorLine' src="/static/img/bot/vectorLine.png" alt="" />
            </div>
        </>
    )
}

export default BotTarifs